import React, { useMemo } from "react";
import PropTypes from "kf-proptypes/widgets";

import { i18n } from "base/i18n";

import {
  SimpleDropdown,
  SIMPLE_DROPDOWN_TYPE
} from "../../inputs/dropdown/simpledropdown/index.jsx";
import {
  ICON_HOVER_TYPE,
  ICON_PADDING,
  ICON_SHAPE,
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";
import { MENU_SIZES, Menu, MenuItem } from "@widgets/inputs/dropdown/menu.jsx";

import styles from "./styles.css";

export function StateChanger({
  label,
  value,
  dataSource,
  onChange = () => {}
}) {
  const {
    currentValueIndex,
    currentLabel,
    currentValue,
    leftIconDisable,
    rightIconDisable
  } = useMemo(
    function findCurrentIndex() {
      const currentIndex = dataSource.findIndex(
        (item) => (item.value || item) === value
      );
      const leftDisable = isNaN(currentIndex) || currentIndex === 0;
      const rightDisable =
        isNaN(currentIndex) || currentIndex === dataSource.length - 1;
      return {
        currentValueIndex: currentIndex,
        currentLabel: dataSource[currentIndex]?.label || value,
        currentValue: dataSource[currentIndex]?.value || value,
        leftIconDisable: leftDisable,
        rightIconDisable: rightDisable
      };
    },
    [dataSource, value]
  );

  function onLeftClick() {
    const prevSelected = dataSource[currentValueIndex - 1];
    onChange(prevSelected.value || prevSelected);
  }
  function onRightClick() {
    const nextSelected = dataSource[currentValueIndex + 1];
    onChange(nextSelected.value || nextSelected);
  }
  function onMenuClick(item) {
    onChange(item.value || item);
  }

  return (
    <div className={`${styles.stateChanger}`}>
      <KfIcon
        icon={
          window.isRTL
            ? KF_ICONS.ARROW_RIGHT_FILLED_1
            : KF_ICONS.ARROW_LEFT_FILLED_1
        }
        size={ICON_SIZE.SIZE_16}
        stroke={ICON_STROKE.BOLD}
        color={leftIconDisable ? "--kf-color-gray-200" : "--kf-color-gray-700"}
        iconShape={ICON_SHAPE.ROUND}
        padding={ICON_PADDING.PADDING_4}
        className={`${styles.navIcon} ${
          leftIconDisable ? styles.disabled : ""
        }`}
        onClick={!leftIconDisable && onLeftClick}
        hoverType={!leftIconDisable ? ICON_HOVER_TYPE.SOLID : ""}
      />
      <SimpleDropdown
        size={SIMPLE_DROPDOWN_TYPE.MEDIUM}
        paddingNone={false}
        value={`${currentLabel}${label ? ` ${label}` : ""}`}
        listRenderer={({ closePopup }) => {
          return (
            <div className={styles.scrollbar}>
              <Menu
                size={MENU_SIZES.TINY}
                selection={currentValue}
                selectable={true}
              >
                {dataSource.map((item) => {
                  return (
                    <MenuItem
                      onClick={() => {
                        onMenuClick(item);
                        closePopup();
                      }}
                      key={item.value || item}
                    >
                      {i18n._(item.label || item)}
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
          );
        }}
      />
      <KfIcon
        icon={
          window.isRTL
            ? KF_ICONS.ARROW_LEFT_FILLED_1
            : KF_ICONS.ARROW_RIGHT_FILLED_1
        }
        size={ICON_SIZE.SIZE_16}
        stroke={ICON_STROKE.BOLD}
        color={rightIconDisable ? "--kf-color-gray-200" : "--kf-color-gray-700"}
        iconShape={ICON_SHAPE.ROUND}
        padding={ICON_PADDING.PADDING_4}
        className={`${styles.navIcon} ${
          rightIconDisable ? styles.disabled : ""
        }`}
        onClick={!rightIconDisable && onRightClick}
        hoverType={!rightIconDisable ? ICON_HOVER_TYPE.SOLID : ""}
      />
    </div>
  );
}

StateChanger.propTypes = {
  /** suffix label */
  label: PropTypes.string.isRequired,
  /** selected value */
  value: PropTypes.string.isRequired,
  /** onChange callback */
  onChange: PropTypes.func.isRequired,
  /** list of items or object {label, value} */
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired
};
